//* Libraries imports
import React from "react";

//* Components imports
import { ProcessExamHeader } from "./process-exam-header";
import { ProcessExamTable } from "./process-exam-table";
import { ProcessExamPagination } from "./process-exam-pagination";

type ProcessExamData = {
  id: number;
  name: string;
  totalQuestions: number;
  disciplinesCount: number;
};
type ProcessExamField = {
  name: string;
  totalQuestions: string;
  header?: string;
  type?: string;
};

type ProcessExamListProps = {
  title: string;
  pronoun?: string;
  searchPlaceholder?: string;
  notFoundMessage: string;
  searchTerm: string;
  onSearchChange: (value: string) => void;
  onSearch: () => void;
  onViewProcessExam?: (id: number) => void;
  onViewExamResults?: (id: number) => void;
  items: ProcessExamData[];
  loading: boolean;
  hideEdit?: boolean;
  hideDelete?: boolean;
  hideView?: boolean;
  hideResults?: boolean;
  fields: ProcessExamField[];
  additionalButtons?: Array<{
    label: string;
    eventHandler: (e: React.MouseEvent) => void;
  }>;

  currentPage?: number;
  totalPages?: number;
  totalItems?: number;
  itemsPerPage?: number;
  onPageChange?: (page: number) => void;
};

export function ProcessExamList({
  title,
  pronoun = "as",
  searchPlaceholder = "Pesquisar...",
  notFoundMessage,
  searchTerm,
  onSearchChange,
  onSearch,
  onViewProcessExam,
  onViewExamResults,
  items,
  loading,
  hideEdit = false,
  hideDelete = false,
  hideResults = false,
  hideView = false,
  fields,
  currentPage = 1,
  totalPages = 1,
  totalItems = 0,
  itemsPerPage = 10,
  onPageChange,
}: ProcessExamListProps) {
  return (
    <div className="container bg-white p-4 rounded-3 shadow-sm">
      {/* Header */}
      <ProcessExamHeader
        title={title}
        pronoun={pronoun}
        searchTerm={searchTerm}
        searchPlaceholder={searchPlaceholder}
        onSearchChange={onSearchChange}
        onSearch={onSearch}
      />

      {/* Table */}
      <div className="mt-4">
        <ProcessExamTable
          items={items}
          loading={loading}
          notFoundMessage={notFoundMessage}
          onViewResult={onViewProcessExam}
          onViewExamResults={onViewExamResults}
          hideEdit={hideEdit}
          hideDelete={hideDelete}
          hideView={hideView}
          hideResults={hideResults}
          fields={fields}
        />
      </div>

      {/* Pagination */}
      {onPageChange && totalPages > 1 && (
        <ProcessExamPagination
          currentPage={currentPage}
          totalPages={totalPages}
          totalItems={totalItems}
          itemsPerPage={itemsPerPage}
          onPageChange={onPageChange}
        />
      )}
    </div>
  );
}
